// extracted by mini-css-extract-plugin
export var active = "_tq-1";
export var circle = "_tq-0";
export var completed = "_tq-2";
export var connector = "_tq-4";
export var connectorCompleted = "_tq-7";
export var connectorSpacer = "_tq-5";
export var iconStrokeOverride = "_tq-8";
export var labelContainer = "_tq-6";
export var pending = "_tq-3";